import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnPlaybackEnded = (params: CommonPlayerEventParams) => {
    return useTriggerOnPlayerEvent(params, 'PLAYBACK_ENDED');
};
